var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXMarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2608_8441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.477132 23.5214C1.12477 24.1543 2.21707 24.1463 2.83372 23.5295L12.0008 14.3608L21.1625 23.5268C21.79 24.1543 22.8811 24.1638 23.5165 23.5188C24.1519 22.8711 24.1547 21.8041 23.5272 21.1741L14.3655 11.9958L23.5272 2.83248C24.1547 2.205 24.1641 1.12593 23.5165 0.490403C22.8689 -0.157342 21.79 -0.160025 21.1625 0.479672L12.0008 9.64298L2.83372 0.476989C2.21707 -0.149294 1.11255 -0.172247 0.477132 0.48772C-0.155601 1.13547 -0.147555 2.21306 0.469086 2.82979L9.63621 11.9958L0.469086 21.1794C-0.147555 21.7934 -0.167821 22.8859 0.477132 23.5214Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2608_8441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMarkIcon);
export default __webpack_public_path__ + "static/media/XMarkIcon.9fac43f9a0cf367cdb6d2b3ca7187177.svg";
export { ForwardRef as ReactComponent };